// extracted by mini-css-extract-plugin
export default {"hideTooltip":"F--z","fadeIn":"G--z","delay":"H--z","recommendedSizeTooltip":"I--z"};